import { TableCell, TableHead, TableRow } from '@mui/material';

// TODO: WE CAN REMOVE THESE WRAPPERS COMPLETELY IN OUR NEXT PASS
export const AdminTableHead = TableHead;
export const AdminTableHeadCell = TableCell;
export const AdminTableRow = TableRow;
export const AdminTableRowDark = TableRow;
